"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideNavItem = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../");
var hooks_1 = require("../../hooks");
var SideNavItem = function (_a) {
    var active = _a.active, children = _a.children, className = _a.className, href = _a.href, onClick = _a.onClick, onFocus = _a.onFocus, onBlur = _a.onBlur, props = __rest(_a, ["active", "children", "className", "href", "onClick", "onFocus", "onBlur"]);
    var itemRef = react_1.default.useRef(null);
    var _b = hooks_1.useFocusVisible(itemRef, onBlur, onFocus), isFocusVisible = _b.isFocusVisible, focusFunction = _b.focusFunction, blurFunction = _b.blurFunction;
    var onClickHandler = function (e) {
        if (!onClick)
            return;
        e.preventDefault();
        onClick(e);
    };
    var El = href ? 'a' : 'span';
    var buttonProps = { href: href };
    var SideNavItemClasses = classnames_1.default('SideNavItem', className, {
        'SideNavItem--active': active,
    });
    var SideNavItemButtonClasses = classnames_1.default('SideNavItem__button', {
        'SideNavItem__button--focus-visible': isFocusVisible,
    });
    return (react_1.default.createElement("li", __assign({ className: SideNavItemClasses }, props),
        react_1.default.createElement(__1.BodyText, __assign({ ref: itemRef, onFocus: focusFunction, onBlur: blurFunction, tabIndex: 0, el: El, size: "small", className: SideNavItemButtonClasses, onClick: onClickHandler }, buttonProps), children)));
};
exports.SideNavItem = SideNavItem;
//# sourceMappingURL=SideNavItem.js.map